// Tier credit allocations + labels for consumers that don't load the plan catalog
// (the sidebar's VisionFoot, AccountSettings). These mirror the deploy-config
// catalog in libs/repositories/vision_billing/src/catalog.rs — keep them in sync.
// Catalog-aware screens (CreditsPage) should read the allocation from
// ListSubscriptionPlans instead of this map.
export const TIER_CREDITS = {
  small: 150,
  medium: 400,
  large: 1200,
  storage_small: 0,
  storage_medium: 0,
  storage_large: 0,
};

export const TIER_LABELS = {
  small: 'Indie',
  medium: 'Pro',
  large: 'Studio',
  storage_small: 'Storage (5 GB)',
  storage_medium: 'Storage (25 GB)',
  storage_large: 'Storage (100 GB)',
};
